import {
  HYDRATE_FROM_LOCAL_STORE,
  NEX_USERNAME_AUTH_SUCCESS,
  NEX_USERNAME_AUTH_FAILURE,
  NEX_REFRESH_AUTH_SUCCESS,
  NEX_REFRESH_AUTH_FAILURE,
  NEX_GTOKEN_AUTH_SUCCESS,
  NEX_GTOKEN_AUTH_FAILURE,
  NEX_SSO_AUTH_LOGIN_SUCCESS,
  NEX_SSO_AUTH_LOGIN_FAILURE,
  NEX_EXTERNAL_TOKEN_AUTH_SUCCESS,
  NEX_EXTERNAL_TOKEN_AUTH_FAILURE,
  LOGOUT_COMPLETE,
  IMPERSONATION_SUCCESS,
  IMPERSONATION_FAILURE,
  END_IMPERSONATION,
  LOAD_GAPI,
  LOAD_GAPI_SUCCESS,
  LOAD_GAPI_FAILURE,
  GAPI_LOGIN_SUCCESS,
  GAPI_LOGIN_FAILURE,
  GAPI_LOGOUT_SUCCESS,
  GAPI_LOGOUT_FAILURE,
  AWS_MKTPLACE_TOKEN_SUCCESS,
  AWS_MKTPLACE_TOKEN_FAILURE,
  NEX_ORG_SWITCH_SUCCESS,
  NEX_ORG_SWITCH_FAILURE,
  SESSION_HISTORY_SUCCESS,
  GAPI_SIGNUP_SUCCESS,
  CLEAR_SESSION_ERROR,
} from 'js/constants/actionTypes';

import { LOGIN_ERROR, LOGIN_UNAUTHORIZED } from 'js/constants/MessageConstants';
import { GAPILoadStatusTypes } from 'js/constants/statusConstants';

import merge from 'lodash/merge';
import has from 'lodash/has';

const initialState = {
  accessToken: null,
  error: null,
  expiresAt: null,
  currentUser: null,
  googleAuth: {
    loadStatus: GAPILoadStatusTypes.GAPI_LOAD_STATUS_INIT,
    profile: null,
    isLoggedIn: false,
    gToken: null,
  },
  isGoogleUser: false,
  impersonatedUser: null,
  awsToken: {
    tokenError: null,
    customer_identifier: null,
    product_code: null,
  },
};

export const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_SESSION_ERROR:
      return clearSessionError(state, action);

    case HYDRATE_FROM_LOCAL_STORE:
      return hydrateSessionFromStore(state, action);

    case NEX_USERNAME_AUTH_SUCCESS:
      return basicSessionStarted(state, action);

    case SESSION_HISTORY_SUCCESS:
      return saveSessionHistory(state, action);

    case NEX_USERNAME_AUTH_FAILURE:
      return basicSessionError(state, action.error);

    case NEX_GTOKEN_AUTH_SUCCESS:
      return gTokenSessionStarted(state, action);

    case NEX_GTOKEN_AUTH_FAILURE:
      return gTokenSessionError(state, action.error);

    case NEX_EXTERNAL_TOKEN_AUTH_SUCCESS:
      return basicSessionStarted(state, action);

    case NEX_EXTERNAL_TOKEN_AUTH_FAILURE:
      return basicSessionError(state, action.error);

    case LOGOUT_COMPLETE:
      return invalidateSession();

    case NEX_ORG_SWITCH_SUCCESS:
    case NEX_REFRESH_AUTH_SUCCESS:
      return refreshTokenSuccess(state, action);

    case NEX_ORG_SWITCH_FAILURE:
    case NEX_REFRESH_AUTH_FAILURE:
      return refreshTokenError(state, action.error);

    case IMPERSONATION_SUCCESS:
      return impersonationSuccess(state, action);

    case IMPERSONATION_FAILURE:
      return impersonationFailure(state, action.error);

    case END_IMPERSONATION:
      return {
        ...state,
        impersonatedUser: null,
      };

    case LOAD_GAPI:
      return {
        ...state,
        googleAuth: {
          loadStatus: GAPILoadStatusTypes.GAPI_LOAD_STATUS_INIT,
          profile: null,
          isLoggedIn: false,
          gToken: null,
        },
      };

    case LOAD_GAPI_SUCCESS: {
      let { gProfile, gToken, isGAuthLoggedIn } = action.payload.gAuthStatus;

      return {
        ...state,
        googleAuth: {
          loadStatus: GAPILoadStatusTypes.GAPI_LOAD_STATUS_READY,
          profile: gProfile,
          isLoggedIn: isGAuthLoggedIn,
          gToken,
        },
      };
    }

    case LOAD_GAPI_FAILURE:
      return {
        ...state,
        googleAuth: {
          loadStatus: GAPILoadStatusTypes.GAPI_LOAD_STATUS_ERROR,
          profile: null,
          isLoggedIn: false,
          gToken: null,
        },
      };

    case GAPI_SIGNUP_SUCCESS:
    case GAPI_LOGIN_SUCCESS:
      let { gProfile, gToken } = action.payload;
      let { googleAuth } = state;
      let newGoogleAuth = {
        ...googleAuth,
        profile: gProfile,
        isLoggedIn: true,
        gToken,
      };
      return {
        ...state,
        error: null,
        googleAuth: newGoogleAuth,
      };
    case GAPI_LOGIN_FAILURE: {
      let { googleAuth } = state;
      let newGoogleAuth = {
        ...googleAuth,
        profile: null,
        isLoggedIn: false,
        gToken: null,
      };
      return {
        ...state,
        error: action.payload.error,
        googleAuth: newGoogleAuth,
      };
    }

    case GAPI_LOGOUT_SUCCESS: {
      let { googleAuth } = state;
      let newGoogleAuth = {
        ...googleAuth,
        profile: null,
        isLoggedIn: false,
        gToken: null,
      };
      return {
        ...state,
        googleAuth: newGoogleAuth,
        isGoogleUser: false,
      };
    }
    case GAPI_LOGOUT_FAILURE:
      console.log('GApi Logout failure' + action.payload.error);
      return state;

    // case NEX_SSO_AUTH_LOGIN_REQUEST:
    //   return ssoSessionReady(state, action);

    case NEX_SSO_AUTH_LOGIN_SUCCESS:
      return ssoSessionStarted(state, action);

    case NEX_SSO_AUTH_LOGIN_FAILURE:
      return ssoSessionError(state, action.error);

    case AWS_MKTPLACE_TOKEN_SUCCESS: {
      let { awsToken } = state;
      const customer_identifier = has(action, 'result.rsp.customer_identifier')
        ? action.result.rsp.customer_identifier
        : null;
      const product_code = has(action, 'result.rsp.product_code')
        ? action.result.rsp.product_code
        : null;
      let newAwsToken = {
        ...awsToken,
        tokenError: null,
        customer_identifier,
        product_code,
      };
      return {
        ...state,
        awsToken: newAwsToken,
      };
    }

    case AWS_MKTPLACE_TOKEN_FAILURE: {
      let { awsToken } = state;

      let newAwsToken = {
        ...awsToken,
        tokenError: has(action, 'message') ? action.message : 'Failed to get customer information',
        customer_identifier: null,
        product_code: null,
      };
      return {
        ...state,
        awsToken: newAwsToken,
      };
    }

    default:
      return state;
  }
};

export default sessionReducer;

function clearSessionError(state, action) {
  return {
    ...state,
    error: null,
  };
}

function hydrateSessionFromStore(state, action) {
  let { entities, result, isGoogleUser } = action;
  if (!entities || !result) {
    return {
      ...state,
    };
  }

  let session = entities.session[result];
  let accessToken = session?.access_token;
  let expiresAt = session?.expiresAt;
  let apiKey = has(session, 'org_membership.api_key') ? session.org_membership.api_key : null;

  let currentUser = {
    user: session?.user,
    org: session?.org,
    token: session?.access_token,
    apiKey,
  };

  let impersonatedUser = null;

  if (action.impersonatedUser) {
    const impersonatedUserId = action.impersonatedUser;
    const impersonatedUserEntity = entities.users[impersonatedUserId];
    const impersonatedSession = entities.session[impersonatedUserId];
    let impersonatedApiKey = has(impersonatedSession, 'org_membership.api_key')
      ? impersonatedSession.org_membership.api_key
      : null;

    impersonatedUser = {
      user: impersonatedUserEntity.id,
      org: impersonatedSession.org,
      token: entities.session[impersonatedUserId].access_token,
      apiKey: impersonatedApiKey,
    };
  }

  return {
    ...state,
    accessToken,
    error: null,
    expiresAt,
    currentUser,
    isGoogleUser,
    impersonatedUser,
  };
}

function basicSessionStarted(state, action) {
  let { entities, result } = action;
  let session = entities.session[result];

  let accessToken = session.access_token;
  let expiresAt = session.expiresAt;
  let apiKey = has(session, 'org_membership.api_key') ? session.org_membership.api_key : null;

  let currentUser = {
    user: session.user,
    org: session.org,
    token: session.access_token,
    apiKey,
  };

  return {
    ...state,
    accessToken,
    error: null,
    expiresAt,
    currentUser,
    isGoogleUser: false,
    impersonatedUser: null,
  };
}

function basicSessionError(state, error) {
  let errorMessage = error !== 'Unauthorized' ? error : LOGIN_ERROR;
  return merge({}, state, { error: errorMessage });
}

function gTokenSessionStarted(state, action) {
  let { entities, result } = action;
  let session = entities.session[result];

  let accessToken = session.access_token;
  let expiresAt = Date.now() + session.expires_in * 1000;
  let apiKey = has(session, 'org_membership.api_key') ? session.org_membership.api_key : null;

  let currentUser = {
    user: session.user,
    org: session.org,
    token: session.access_token,
    apiKey,
  };

  return {
    ...state,
    accessToken,
    error: null,
    expiresAt,
    currentUser,
    isGoogleUser: true,
    impersonatedUser: null,
  };
}

function gTokenSessionError(state, error) {
  let errorMessage = error !== 'Unauthorized' ? error : LOGIN_UNAUTHORIZED;
  return merge({}, state, { error: errorMessage });
}

function ssoSessionStarted(state, action) {
  let { entities, result } = action;
  let session = entities.session[result];

  let accessToken = session.access_token;
  let expiresAt = Date.now() + session.expires_in * 1000;
  let apiKey = has(session, 'org_membership.api_key') ? session.org_membership.api_key : null;

  let currentUser = {
    user: session.user,
    org: session.org,
    token: session.access_token,
    apiKey,
  };

  return {
    ...state,
    accessToken,
    error: null,
    expiresAt,
    currentUser,
    impersonatedUser: null,
  };
}

function ssoSessionError(state, error) {
  let errorMessage =
    error !== 'Unauthorized'
      ? error
      : 'There was an error in authorizing this user. Please make sure you entered the correct authentication information';

  return {
    ...state,
    error: errorMessage,
  };
}

function saveSessionHistory(state, action) {
  let { result } = action;
  return {
    ...state,
    login_history: result.login_history,
    logout_history: result.logout_history,
  };
}

function refreshTokenSuccess(state, action) {
  let { entities, result } = action;
  let session = entities.session[result];

  let accessToken = session.access_token;
  let expiresAt = Date.now() + session.expires_in * 1000;
  let apiKey = has(session, 'org_membership.api_key') ? session.org_membership.api_key : null;

  let currentUser = {
    user: session.user,
    org: session.org,
    token: session.access_token,
    apiKey,
  };

  return {
    ...state,
    accessToken,
    error: null,
    expiresAt,
    currentUser,
  };
}

function refreshTokenError(state, error) {
  let errorMessage = error !== 'Unauthorized' ? error : LOGIN_UNAUTHORIZED;
  return merge({}, state, { error: errorMessage });
}

function impersonationSuccess(state, action) {
  const userId = action.result;
  const session = action.entities.session[userId];
  const token = session.access_token;
  const orgId = session.org;
  let apiKey = has(session, 'org_membership.api_key') ? session.org_membership.api_key : null;

  return {
    ...state,
    impersonatedUser: {
      user: userId,
      org: orgId,
      token: token,
      apiKey,
    },
  };
}

function impersonationFailure(state, error) {
  const errorMessage = error !== 'Unauthorized' ? error : LOGIN_UNAUTHORIZED;
  return { ...state, error: errorMessage };
}

function invalidateSession() {
  let googleAuth = {
    ...initialState.googleAuth,
    loadStatus: GAPILoadStatusTypes.GAPI_LOAD_STATUS_READY,
  };
  return { ...initialState, googleAuth };
}
